import SortUtil from "./sort";
import moment from "moment-timezone/builds/moment-timezone-with-data";
import { Series } from "@amcharts/amcharts4/charts";
import { cloneDeep, round } from "lodash";
const format = {
  date: (d, sep = "-") => {
    var year = d.getFullYear();
    var month = d.getMonth() + 1;
    var day = d.getDate();
    if (month < 10) month = "0" + month;
    if (day < 10) day = "0" + day;
    return year + sep + month + sep + day;
  },
  mapAlarmCountFieldsToChart: (object) => {
    if (object != null) {
      if (Object.keys(object).length !== 0) {
        let mappedObj = [];
        object.map((obj) => {
          mappedObj.push({
            text: obj.text,
            count: obj.count,
            duration: format.msToHours(obj.duration) || 0,
          });
        });
        return mappedObj;
      }
    }
    return [];
  },
  getTimeStrFromIsoStrDate: (d) => {
    return d.substring(d.indexOf("T") + 1, d.length);
  },
  getGridDateFormat: (d) => {
    let date = format.getDDMMYYYYDate(d);
    let time =
      ("00" + d.getHours()).slice(-2) +
      ":" +
      ("00" + d.getMinutes()).slice(-2) +
      ":" +
      ("00" + d.getSeconds()).slice(-2) +
      "." +
      ("000" + d.getMilliseconds()).slice(-3);
    return date + " " + time;
  },

  getDDMMYYYYDate: (d) => {
    var year = d.getFullYear();
    var month = d.getMonth() + 1;
    var day = d.getDate();
    if (month < 10) month = "0" + month;
    if (day < 10) day = "0" + day;
    return day + "." + month + "." + year;
  },
  getMaxDateFromArrayOfObjects: (arr, dateFieldName) => {
    const maxDate = new Date(
      Math.max(
        ...arr.map((element) => {
          return new Date(element[dateFieldName]);
        })
      )
    );
    return maxDate;
  },
  getMaxTimelineDateFromArrayOfObjects: (arr, dateFieldName) => {
    const maxDate = new Date(
      Math.max(
        ...arr.map((element) => {
          return new Date(
            element[dateFieldName].split("T")[0] + "T23:59:59.999"
          );
        })
      )
    );
    return maxDate;
  },
  getMinDateFromArrayOfObjects: (arr, dateFieldName) => {
    const minDate = new Date(
      Math.min(
        ...arr.map((element) => {
          return new Date(element[dateFieldName]);
        })
      )
    );
    return minDate;
  },
  getPastDate: (d, shift = 1) => {
    let yesterday = new Date(d);
    yesterday.setDate(yesterday.getDate() - shift);
    return new Date(yesterday);
  },
  getFutureDate: (d, shift = 1) => {
    let tomorrow = new Date(d);
    tomorrow.setDate(tomorrow.getDate() + shift);
    return new Date(tomorrow);
  },
  getRandomIntNumber(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  },
  msToHours: (s) => {
    let ms = s % 1000;
    s = (s - ms) / 1000;
    let secs = s % 60;
    s = (s - secs) / 60;
    let mins = s % 60;
    let hrs = (s - mins) / 60;
    //
    let minsInHrs = mins / 60;
    let secondsInHrs = secs / 3600;
    //
    let totalHours = hrs + minsInHrs + secondsInHrs;
    if (totalHours < 1) {
      return round(totalHours, 2);
    }
    if (totalHours < 10) {
      return round(totalHours, 1);
    }
    return round(totalHours);
  },
};
export const msToHours = (s) => {
  let ms = s % 1000;
  s = (s - ms) / 1000;
  let secs = s % 60;
  s = (s - secs) / 60;
  let mins = s % 60;
  let hrs = (s - mins) / 60;
  //
  let minsInHrs = mins / 60;
  let secondsInHrs = secs / 3600;
  //
  let totalHours = hrs + minsInHrs + secondsInHrs;
  if (totalHours < 1) {
    return round(totalHours, 2);
  }
  if (totalHours < 10) {
    return round(totalHours, 1);
  }
  return round(totalHours);
};
export default format;
